// 验证手机号
export function validMobile(value) {
  let regs = /^1[3456789]\d{9}$/
  return regs.test(value)
}

// 验证身份证
export function validIDCard(value) {
  var num = value.toUpperCase() || ''
  // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
  var reg = /^(\d{18,18}|\d{15,15}|\d{17,17}X)$/
  if (!reg.test(num)) {
    return false
  } else {
    return true
  }
}

// 验证护照和港澳通行证
export function validPassport(value) {
  var num = value.toUpperCase() || ''
  var reg1 = /^[a-zA-Z]\d{7}$/
  var reg2 = /^[a-zA-Z]\d{7,8}$/
  var reg3 = /^[A-Z]\d{9}$/

  if (reg1.test(num) || reg2.test(num) || reg3.test(num)) {
    return true
  } else {
    return false
  }
}

// 验证身份证里的出生日期与出生年份是否匹配
export function validIDCardByBirth(value, birthForYear) {
  if (validIDCard(value)) {
    if (!birthForYear) {
      return false
    } else {
      let year = value.substr(6, 4)
      if (year == birthForYear) {
        return true
      } else {
        return false
      }
    }
  } else {
    return false
  }
}